import { DefaultState } from 'store/reducers/types';

export const READ_ISSUES_DATA_REQUEST = "READ_ISSUES_DATA_REQUEST";
export const READ_ISSUES_DATA_SUCCESS = "READ_ISSUES_DATA_SUCCESS";
export const READ_ISSUES_DATA_FAILURE = "READ_ISSUES_DATA_FAILURE";

export interface IssuesData {
  noShowTD: number;
  noShowYD: number;
  lateCancellationTD: number;
  lateCancellationYD: number;
};

export type IssuesState = DefaultState & {
  contents?: IssuesData;
};

interface ReadIssuesDataRequest {
  type: typeof READ_ISSUES_DATA_REQUEST;
};

interface ReadIssuesDataSuccess {
  type: typeof READ_ISSUES_DATA_SUCCESS,
  contents: IssuesData;
};

interface ReadIssuesDataFailure {
  type: typeof READ_ISSUES_DATA_FAILURE;
};

export type IssuesActionTypes = ReadIssuesDataRequest | ReadIssuesDataSuccess | ReadIssuesDataFailure;